import React from "react";
import JournalFormPage from "../components/journals/JournalFormPage";

const JournalCreate = () => <JournalFormPage mode="create" />;

export default JournalCreate;
